import React from 'react';
import AuthorizationCodeField from 'components/Fields/ReduxForm/AuthorizationCodeField';
import { Field, untouch, change } from 'redux-form';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './AssignPasscode.css';

class AssignPasscode extends React.Component {
  render() {
    const {
      assignPin,
      selfView,
      disabled,
      checked,
      posAccess,
      pinAccessImprovement,
    } = this.props;
    const className = assignPin ? styles['show-pin'] : styles['hide-pin'];

    return (
      <div>
        <div className={`${styles['checkbox-wrapper']} col-xs-1`}>
          {!posAccess && pinAccessImprovement ? (
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="tooltip">
                  Disabled due to the role selected does not have App
                  Permission. You can change permission setting on
                  <Link to="/employee/role"> Employee Access</Link>
                </Tooltip>
              }
            >
              <div>
                <Field
                  component="input"
                  type="checkbox"
                  name="assign_pin"
                  disabled={selfView || disabled || checked || !posAccess}
                  onChange={this._onChangeCheckbox}
                />
              </div>
            </OverlayTrigger>
          ) : (
            <Field
              component="input"
              type="checkbox"
              name="assign_pin"
              disabled={
                pinAccessImprovement
                  ? selfView || disabled || checked || !posAccess
                  : selfView || disabled || checked
              }
              onChange={this._onChangeCheckbox}
            />
          )}
        </div>
        <div className={`${styles['passcode-wrapper']} col-xs-11`}>
          <div>
            <span>Assign a PIN</span>
          </div>
          <div className={`${styles['auth-code-text']}`}>
            {!pinAccessImprovement && (
              <small>
                Go to <Link to="/employees/pin">PIN Access</Link> to allow
                employees access to certain parts of your Point of Sale using
                their 4-digit PIN
              </small>
            )}
          </div>
          <Field
            name="pin"
            component={AuthorizationCodeField}
            placeholder="4 Digits PIN"
            maxLength={4}
            className={className}
            disabled={selfView || disabled}
          />
        </div>
        {pinAccessImprovement && (
          <div>
            <div className={`${styles['checkbox-wrapper']} col-xs-1`} />
            <div
              className={`${styles['passcode-wrapper']} col-xs-8 ${className}`}
            >
              <div className={`${styles['checkbox-wrapper']} col-xs-1`}>
                <Field
                  component="input"
                  type="checkbox"
                  name="is_enable_in_app_permission"
                  disabled={selfView || disabled || checked}
                />
              </div>
              <div>
                <small>
                  Allow employee to use PIN for in-app permission set on{' '}
                  <Link to="/employees/pin">PIN Access</Link>
                </small>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  _onChangeCheckbox = () => {
    if (!this.props.currentPin || this.props.currentPin === '') {
      this.props.dispatch(untouch('staff', 'pin'));
      if (this.props.pinAccessImprovement) {
        this.props.dispatch(change('staff', 'pin', this.props.generatedPin));
      }
    }
  };
}

AssignPasscode.propTypes = {
  assignPin: PropTypes.bool,
  selfView: PropTypes.bool,
  dispatch: PropTypes.func,
  currentPin: PropTypes.number,
  checked: PropTypes.bool,
  isEnableInAppPermission: PropTypes.bool,
  posAccess: PropTypes.bool,
};

const mapFlagsToProps = flags => ({
  pinAccessImprovement: flags.pinAccessImprovement,
});

export default withFeatureFlags(mapFlagsToProps)(AssignPasscode);
